import { call, takeLatest, put, } from 'redux-saga/effects';
import {  getUserAttributes, getUserAttributesSuccess, getUserAttributesFailure} from '../actions/amazonWebServicesAction';
import { getUserInfoAndCheckAdmin } from '../../api/api';

export function* updateUserAttributes(action){
   try {
      const response = yield call(getUserInfoAndCheckAdmin, action);
      yield put(getUserAttributesSuccess(response));
   } catch (e) {
      yield put(getUserAttributesFailure(e));
   }
}

function* amazonWebServicesSaga() {
   yield takeLatest(getUserAttributes, updateUserAttributes);
}

export default amazonWebServicesSaga;
